// schema.org Service JSON-LD for the service landing pages, returned as a string
// for a <script type="application/ld+json"> inside the page's <Helmet>.
export function serviceSchemaJson({ name, description, path }) {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    serviceType: name,
    description,
    url: `https://360synergytech.com${path}`,
    provider: {
      "@type": "Organization",
      name: "360 SynergyTech",
      url: "https://360synergytech.com/",
    },
  });
}
